import { type JSX } from "react";
import { VerticalSpacing } from "../VerticalSpacing"
import { CTextIcon, StepText, StepWrapper } from "./MarketingSteps.styles"
import { Step1Spacing, TrailSVGStep1 } from "./Step1.styles"


interface Step1Props {
    leftSide: JSX.Element,
    rightSide: JSX.Element
}

export const Step1 = ({ leftSide, rightSide }: Step1Props) => {
    return <Step1Spacing>
        <StepWrapper>
            <div>
                <StepText>
                    <VerticalSpacing bottom={16}>
                        <CTextIcon>
                            <svg width="24" height="1" viewBox="0 0 24 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line y1="0.5" x2="24" y2="0.5" stroke="#2E77FF" />
                            </svg>
                            <div>
                                Step 1
                            </div>
                        </CTextIcon>
                    </VerticalSpacing>
                    {leftSide}
                </StepText>
            </div>
            <div>
                {rightSide}
            </div>
            <TrailSVGStep1 src="/authory_static_files/images/how-it-works/trail.svg" />
        </StepWrapper>
    </Step1Spacing>
}